module.exports = __webpack_public_path__ + "img/Live_Data_Icon_Up.e046cc3f.svg";